// @flow
import type {Element} from 'react'
import React, {Component} from 'react'

import Modal from 'components/ui/Modal'
import Clipboard from 'components/ui/icons/md/Clipboard'
import flash from 'utils/MiscUtils/flash'
import IconButton from 'components/ui/Inputs/IconButton'
import EditForm from './EditForm'

type Props = {
  onClick: Function,
}

type State = {
  isOpen: boolean,
  roleText: string,
}

class PasteRoleButton extends Component<Props, State> {
  state: State = {
    isOpen: false,
    roleText: '',
  }

  onChange: ((event: any) => void) = (event: Object) => {
    this.setState({roleText: event.currentTarget.value})
  }

  onSubmit: (() => void) = () => {
    try {
      this.props.onClick(this.state.roleText)
    } catch (e) {
      flash.danger(`Unable to add role: ${e}`)
    }
    this.resetFn()
  }

  toggleOpen: (() => void) = () => {
    this.setState(({isOpen}) => ({isOpen: !isOpen, roleText: ''}))
  }

  resetFn: (() => void) = () => {
    this.setState({isOpen: false, roleText: ''})
  }

  renderModal: (() => Element<"div">) = () => (
    <div className="refinery-paste-role-button__modal">
      <Modal
        size="lg"
        autofocus={false}
        close={this.toggleOpen}
      >
        <Modal.Header
          title={I18n.t('proposals.react.paste_role_definition')}
          close={this.toggleOpen}
        />
        <Modal.Body>
          <EditForm
            onChange={this.onChange}
            text={this.state.roleText}
          />
        </Modal.Body>
        <Modal.Footer
          rightBlock={(
            <button
              className="btn btn-primary"
              onClick={this.onSubmit}
              type="button"
            >
              {I18n.t('proposals.react.submit')}
            </button>
          )}
        />
      </Modal>
    </div>
  )

  render(): Element<"div"> {
    return (
      <div className="refinery-paste-role-button mb-3">
        <div className="refinery-paste-role-button__modal-trigger">
          <IconButton
            onClick={this.toggleOpen}
            title={I18n.t('react.components.clipboard.copy')}
          >
            <Clipboard />
          </IconButton>
        </div>
        {this.state.isOpen && this.renderModal()}
      </div>
    )
  }
}

export default PasteRoleButton
